import {
  MidasOfferPageData,
  MidasTermsAndCondition,
} from 'types/order-join-flow';

import { ensureMediaRelation } from './media';

type TermAttrs = {
  terms?: MidasTermsAndCondition['Attributes']['terms'];
  Terms?: MidasTermsAndCondition['Attributes']['terms'];
};

type TermsAndConditionsAttributes = {
  Attributes?: Exclude<MidasTermsAndCondition['Attributes'], 'Terms'> &
    TermAttrs;
  attributes?: Exclude<MidasTermsAndCondition['Attributes'], 'terms'> &
    TermAttrs;
};

type Terms = {
  data?: { id: number } & TermsAndConditionsAttributes;
  Data?: { id: number } & TermsAndConditionsAttributes;
};

export function normalizeOfferPageData(
  offer: MidasOfferPageData,
): MidasOfferPageData {
  const sidebar = offer?.attributes?.midas_sidebar;
  const sidebarData = sidebar?.data;
  const sidebarAttributes = sidebarData?.attributes;
  const terms = offer?.attributes?.midas_terms_and_condition as Terms;
  const termsData = terms?.data ?? terms?.Data;
  const termsAttrs = termsData?.Attributes ?? termsData?.attributes;
  const termsArray = termsAttrs?.terms ?? termsAttrs?.Terms;
  const defaultDate = new Date('2024-07-31T20:23:39.113Z');

  const sidebarFeaturedCard = sidebarAttributes?.featuredCard;

  const normalizedSidebarFeaturedCard = sidebarFeaturedCard
    ? {
        featuredCard: {
          ...sidebarFeaturedCard,
          image: ensureMediaRelation(sidebarFeaturedCard.image),
          mobileImage: ensureMediaRelation(sidebarFeaturedCard.mobileImage),
        },
      }
    : {};

  const normalizedSidebarAttributes = sidebarAttributes
    ? {
        ...sidebarAttributes,
        mobile_hero_image: ensureMediaRelation(
          sidebarAttributes.mobile_hero_image,
        ),
        desktop_hero_image: ensureMediaRelation(
          sidebarAttributes.desktop_hero_image,
        ),
        featured_image: ensureMediaRelation(sidebarAttributes.featured_image),
        ...normalizedSidebarFeaturedCard,
      }
    : {
        createdAt: defaultDate,
        updatedAt: defaultDate,
        SidebarItem: [],
        AtkInternalIdentifier: '',
        sidebarStyleVariant: '',
        desktop_hero_image: ensureMediaRelation(undefined),
        mobile_hero_image: ensureMediaRelation(undefined),
        featuredCard: {
          id: 0,
          title: '',
          subTitle: '',
          description: '',
          image: ensureMediaRelation(undefined),
          mobileImage: ensureMediaRelation(undefined),
        },
        ...normalizedSidebarFeaturedCard,
      };

  return {
    ...offer,
    attributes: {
      ...offer.attributes,
      midas_sidebar: {
        ...sidebar,
        data: {
          ...sidebarData,
          attributes: normalizedSidebarAttributes,
        },
      },
      midas_terms_and_condition: {
        Data: {
          id: termsData?.id ?? 0,
          Attributes: {
            createdAt: termsData?.Attributes?.createdAt ?? defaultDate,
            updatedAt: termsData?.Attributes?.updatedAt ?? defaultDate,
            publishedAt: termsData?.Attributes?.publishedAt ?? defaultDate,
            AtkInternalIdentifier: termsAttrs?.AtkInternalIdentifier ?? '',
            terms: termsArray ?? [],
          },
        },
      },
    },
  };
}
